import { render, staticRenderFns } from "./SearchSVG.vue?vue&type=template&id=97e6b9fa"
import script from "./SearchSVG.vue?vue&type=script&lang=js"
export * from "./SearchSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports